import React from "react";

import AdminItems from "./AdminItems";
import GerenteRegionalItems from "./GerenteRegionalItems";
import GerenteSetorItems from "./GerenteSetorItems";
import RepresentanteItems from "./RepresentanteItems";

import { GetUser } from "../../services/auth";

const Home: React.FC = () => {

    return (
        <>
            {GetUser().role === "Admin" && <AdminItems />}
            {GetUser().role === "Operador" && <AdminItems />}
            {GetUser().role === "GerenteR" && <GerenteRegionalItems />}
            {GetUser().role === "GerenteS" && <GerenteSetorItems />}
            {GetUser().role === "Representante" && <RepresentanteItems />}
        </>
    );
};

export default Home;
